import { Component } from 'react';
import { Button, Card, Form, Alert, InputGroup, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { GET, POST } from '../../api';
import { getUrlParam } from '../../helpers/general_helpers';
import GetIcon from '../../helpers/icon_helper';

const createBillURL = 'payment-gateway-rosom/create-bill';
const verifyPaymentURL = 'payment-gateway-rosom/verify-payment';

class PaymentGatewayRosom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      creatingBill: false,
      verifying: false,
      billData: null,
      paymentStatusResult: null,
      copied: false,
      balance: 0,
      formCheckOut: {
        parentName: '',
        childName: '',
        mobileNo: '',
        email: '',
      },
    };
  }

  componentDidMount() {
    if (this.props.params) {
      this.setState({
        balance: this.props.params.balance || 0,
        formCheckOut: {
          parentName: this.props.params.parent_name || '',
          childName: this.props.params.child_name || '',
          mobileNo: this.props.params.mobile || this.props.params.phone || '0500000000',
          email: this.props.params.email || this.props.params.email1 || '',
        },
      });
    }

    const urlParams = getUrlParam();
    const sadadNumber = urlParams.sadadNumber || urlParams.sadad_number;
    const invoiceId = urlParams.invoiceId || urlParams.orderId || urlParams.inv_id;

    if (sadadNumber || invoiceId) {
      this.verifyPayment(sadadNumber, invoiceId);
    }
  }

  createBill = async (e) => {
    if (e) e.preventDefault();
    const { processing, creatingBill, formCheckOut, balance } = this.state;
    if (processing || creatingBill) return;

    const amountToPay = balance || this.props.params?.balance;
    if (!amountToPay || amountToPay <= 0) {
      toast.error(t('Amount is required!'));
      return;
    }

    if (!formCheckOut.mobileNo) {
      toast.error(t('Mobile number is required for SADAD notification!'));
      return;
    }

    this.setState({ creatingBill: true, processing: true });

    try {
      const fData = new FormData();
      fData.append('amount', amountToPay);
      fData.append('data', JSON.stringify({
        ...formCheckOut,
        child_id: this.props.params?.child_id,
        parent_id: this.props.params?.parent_id,
      }));

      const paramsToSend = {
        tenant_id: this.props.tenant_id,
        center_id: this.props.params?.center_id,
        parent_id: this.props.params?.parent_id,
        child_id: this.props.params?.child_id,
        user_id: this.props.params?.user_id,
        actionType: this.props.params?.actionType,
        child_name: formCheckOut.childName,
        parent_name: formCheckOut.parentName,
      };

      const res = await POST(createBillURL, fData, { params: paramsToSend });
      const resData = res ? res.data : null;

      if (!resData || (!resData.success && !resData.type)) {
        toast.error(resData?.message || t('Could not generate SADAD Bill. Please try again.'));
        this.setState({ creatingBill: false, processing: false });
        return;
      }

      toast.success(t('SADAD Bill generated successfully!'));
      this.setState({
        billData: resData.data,
        creatingBill: false,
        processing: false,
      });
    } catch (err) {
      toast.error(t('Could not generate SADAD Bill. Please check connection and try again.'));
      this.setState({ creatingBill: false, processing: false });
    }
  };

  verifyPayment = async (sadadNumber, invoiceId) => {
    const sNum = sadadNumber || this.state.billData?.sadadNumber;
    const invId = invoiceId || this.state.billData?.invoiceId;

    if (!sNum && !invId) {
      toast.info(t('Please generate a SADAD Bill first.'));
      return;
    }

    this.setState({ verifying: true });

    try {
      const res = await GET(verifyPaymentURL, {
        params: {
          sadadNumber: sNum,
          invoiceId: invId,
          center_id: this.props.params?.center_id,
          user_id: this.props.params?.user_id,
          tenant_id: this.props.tenant_id,
        },
      });

      const resData = res ? res.data : null;

      if (resData && resData.type) {
        toast.success(t('Payment verified successfully!'));
        this.setState({
          paymentStatusResult: resData,
          verifying: false,
        });
      } else {
        toast.info(resData?.message || t('Bill is still awaiting payment via SADAD.'));
        this.setState({ verifying: false });
      }
    } catch (err) {
      toast.error(t('Could not check payment status.'));
      this.setState({ verifying: false });
    }
  };

  copySadadNumber = () => {
    const sNum = this.state.billData?.sadadNumber;
    if (sNum && navigator.clipboard) {
      navigator.clipboard.writeText(sNum);
      this.setState({ copied: true });
      toast.success(t('SADAD Number copied to clipboard!'));
      setTimeout(() => this.setState({ copied: false }), 3000);
    }
  };

  render() {
    const { params } = this.props;
    const { formCheckOut, creatingBill, verifying, processing, billData, paymentStatusResult, copied } = this.state;
    const busy = creatingBill || processing;

    if (paymentStatusResult && paymentStatusResult.type) {
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
            <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
              {t('Payment Successful')}
            </div>
          </Card.Header>
          <Card.Body className="text-center p-4">
            <div className="my-3">
              <GetIcon icon="LuBadgeCheck" style={{ fontSize: 60, color: '#10B981' }} />
            </div>
            <h5 className="mb-3" style={{ color: '#10B981', fontWeight: 600 }}>
              {t('SADAD Payment Confirmed')}
            </h5>
            <p className="text-muted">
              {t('Your bill payment has been successfully processed through the SADAD Payment System.')}
            </p>
            <Table borderless striped className="text-start mt-4">
              <tbody>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('SADAD Bill No')}</th>
                  <td style={{ textAlign: 'left' }}>{paymentStatusResult.data?.sadadNumber || billData?.sadadNumber || '-'}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('Student Name')}</th>
                  <td style={{ textAlign: 'left' }}>{params?.child_name}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('Amount')}</th>
                  <td style={{ textAlign: 'left' }}>{(params?.balance || billData?.amountDue) + ' ' + (params?.currencycode || 'SAR')}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('Status')}</th>
                  <td style={{ textAlign: 'left' }}>
                    <span className="badge bg-success">{t('PAID')}</span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
          <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
            <Button
              variant="success"
              style={{ width: '100%' }}
              onClick={() => {
                window.location.href = window.location.origin + window.location.pathname;
              }}
            >
              {t('Done')}
            </Button>
          </Card.Footer>
        </Card>
      );
    }

    if (billData && billData.sadadNumber) {
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
            <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
              {t('SADAD Bill Generated')}
            </div>
          </Card.Header>
          <Card.Body className="p-4">
            <div
              className="p-4 text-center mb-4"
              style={{
                backgroundColor: '#F0FDF4',
                border: '2px dashed #10B981',
                borderRadius: '16px',
              }}
            >
              <div style={{ color: '#065F46', fontSize: 14, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>
                {t('SADAD Bill Account Number')}
              </div>
              <div
                className="d-flex flex-row justify-content-center align-items-center my-2"
                style={{ cursor: 'pointer' }}
                onClick={this.copySadadNumber}
                title={t('Click to copy')}
              >
                <span style={{ fontSize: 32, fontWeight: 700, color: '#047857', letterSpacing: 2 }}>
                  {billData.sadadNumber}
                </span>
                <Button
                  variant="outline-success"
                  size="sm"
                  className="ms-3"
                  onClick={this.copySadadNumber}
                >
                  {copied ? t('Copied!') : t('Copy')}
                </Button>
              </div>
              <div style={{ color: '#047857', fontSize: 13 }}>
                {t('Amount Due')}: <strong>{params?.balance || billData.amountDue} {params?.currencycode || 'SAR'}</strong>
              </div>
            </div>

            <Alert variant="info" className="mb-4">
              <div style={{ fontWeight: 600, marginBottom: 6 }}>
                <GetIcon icon="LuBadgeInfo" style={{ marginRight: 8 }} />
                {t('How to Pay via SADAD')}:
              </div>
              <ol className="mb-0 ps-3" style={{ fontSize: 13, lineHeight: 1.8 }}>
                <li>{t('Open your Bank Mobile App or Online Banking (e.g. Al Rajhi, SNB, Riyad Bank, etc.)')}</li>
                <li>{t('Navigate to Bill Payments / SADAD Bills section.')}</li>
                <li>{t('Select ROSOM or search for the school biller code.')}</li>
                <li>{t('Enter the SADAD Bill Number')}: <strong>{billData.sadadNumber}</strong></li>
                <li>{t('Confirm and complete the bill payment.')}</li>
              </ol>
            </Alert>

            <Table borderless striped>
              <tbody>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('Parent Name')}</th>
                  <td style={{ textAlign: 'left' }}>{params?.parent_name}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('Student Name')}</th>
                  <td style={{ textAlign: 'left' }}>{params?.child_name}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>{t('Invoice ID')}</th>
                  <td style={{ textAlign: 'left' }}>#{billData.invoiceId || '-'}</td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>

          <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
            <div className="d-flex flex-column gap-2">
              <Button
                variant="primary"
                style={{ width: '100%' }}
                disabled={verifying}
                onClick={() => this.verifyPayment(billData.sadadNumber, billData.invoiceId)}
              >
                {verifying && <Spinner animation="grow" size="sm" className="me-2" />}
                {t('Check Payment Status')}
              </Button>
              <Button
                variant="outline-secondary"
                size="sm"
                style={{ width: '100%' }}
                onClick={() => this.setState({ billData: null })}
              >
                {t('Back to Bill Form')}
              </Button>
            </div>
          </Card.Footer>
        </Card>
      );
    }

    return (
      <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
        <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
          <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
            {t('ROSOM / SADAD Payment')}
          </div>
        </Card.Header>
        <Card.Body>
          <Table borderless striped>
            <thead>
              <tr>
                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>
                  {t('Summary')}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>{t('Parent Name')}</th>
                <td style={{ textAlign: 'left' }}>{params?.parent_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>{t('Student Name')}</th>
                <td style={{ textAlign: 'left' }}>{params?.child_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>{t('Amount Due')}</th>
                <td style={{ textAlign: 'left' }}>{params?.balance + ' ' + params?.currencycode}</td>
              </tr>
            </tbody>
          </Table>

          <Alert variant="warning" className="my-3 text-center" style={{ fontSize: 13 }}>
            <GetIcon icon="LuBadgeAlert" style={{ marginRight: 6 }} />
            {t('Clicking Generate SADAD Bill will create an official SADAD invoice that you can pay via your Saudi bank mobile app or ATM.')}
          </Alert>

          <Table borderless striped>
            <tbody>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 130 }}>{t('Parent Name')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.parentName}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, parentName: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 130 }}>{t('Student Name')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.childName}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, childName: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 130 }}>{t('Mobile No')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="05XXXXXXXX"
                      value=""
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, mobileNo: e.target.value } })}
                    />
                  </InputGroup>
                  <Form.Text className="text-muted ps-2" style={{ fontSize: 12 }}>
                    {t('SADAD Bill details and payment SMS will be sent to this number.')}
                  </Form.Text>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>

        <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
          <Form onSubmit={this.createBill}>
            <Button variant="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              <div className="d-flex flex-row justify-content-center align-items-center">
                {busy && <Spinner animation="grow" variant="dark" className="mx-1" />}
                <div className="mx-1">{t('Generate SADAD Bill')}</div>
                <div className="mx-1" style={{ fontWeight: 600 }}>{params?.currencycode}</div>
                <div className="mx-1 px-2" style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>
                  {params?.balance}
                </div>
              </div>
            </Button>
          </Form>
        </Card.Footer>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps())(PaymentGatewayRosom);